import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import InputGroupWrapper from '../../InputGroupWrapper';
import messages from '../registrationMessages';
import FormGroupPart from './FormGroupPart';

import VatRateTypeSelector from '../../input/VatRateTypeSelector';

const VatPercentagePart = ({ vatPercentage, vatType, onChange, disabled, className }) => (
  <FormGroupPart label={messages.VAT}>
    <InputGroupWrapper
      className={classnames('input-group-sm', { disabled: disabled }, className)}
      left="%"
    >
      <VatRateTypeSelector
        vatRate={vatPercentage}
        vatType={vatType}
        onChange={onChange}
        disabled={disabled}
      />
    </InputGroupWrapper>
  </FormGroupPart>
);
VatPercentagePart.propTypes = {
  vatPercentage: PropTypes.number,
  vatType: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
VatPercentagePart.defaultProps = {
  vatPercentage: 0,
  vatType: 0,
  disabled: false,
  className: '',
};
export default VatPercentagePart;
